import * as React from "react";

const styles = require("./styles.module.scss");

const RateInput = ({
  updatedRate,
  onEdit,
  suffix,
}: {
  updatedRate: string;
  onEdit: Function;
  suffix: string;
}) => (
  <div className={styles.container}>
    <input type="text" name="rate" value={updatedRate} onChange={e => onEdit(e.target.value)} />
    <span>{suffix}</span>
  </div>
);

export default RateInput;
